import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";

import i18n from "i18next";
import { Analytics } from "../../analytics";
import { langToPath, pathToLang } from "../../router/LangWrapper";
import {
  FooterSection,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Large,
  Chat,
  FooterContainer,
  Language,
  Label,
  LanguageSwitch,
  LanguageSwitchContainer,
} from "./styles";

interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = ({ t }: { t: TFunction }) => {
  const history = useHistory();
  const location = useLocation();
  const currentLangPath = pathToLang(location.pathname);
  const homePath = currentLangPath ? langToPath(currentLangPath) : "/";

  const handleChange = (language: string) => {
    Analytics.languageSwitch(language);
    i18n.changeLanguage(language);
    history.push(langToPath(language));
  };

  const SocialLink = ({ href, src }: SocialLinkProps) => (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      key={src}
      aria-label={src}
    >
      <SvgIcon src={src} width="25px" height="25px" />
    </a>
  );

  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="space-between">
            {/* Contact Section */}
            <Col lg={12} md={12} sm={24} xs={24}>
              <Language>{t("Contact")}</Language>
              <Large to={homePath}>{t("Tell us everything")}</Large>
              <Para>
                {t(`Do you have any question? Feel free to reach out.`)}
              </Para>
              <a href="mailto:team@dailydisciple.co">
                <Chat>{t(`Let's Chat`)}</Chat>
              </a>
            </Col>

            {/* Language Switcher */}
            <Col lg={12} md={12} sm={24} xs={24}>
              <Label htmlFor="select-lang">{t("Language")}</Label>
              <LanguageSwitchContainer>
                <LanguageSwitch onClick={() => handleChange("en")}>
                  <SvgIcon
                    src="united-states.svg"
                    aria-label="english"
                    width="30px"
                    height="30px"
                  />
                </LanguageSwitch>
                <LanguageSwitch onClick={() => handleChange("es")}>
                  <SvgIcon
                    src="spain.svg"
                    aria-label="spanish"
                    width="30px"
                    height="30px"
                  />
                </LanguageSwitch>
              </LanguageSwitchContainer>
            </Col>
          </Row>
        </Container>
      </FooterSection>

      {/* Bottom Extra Section */}
      <Extra>
        <Container border={true}>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "3rem" }}
          >
            <NavLink to={homePath}>
              <LogoContainer>
                <SvgIcon
                  src="logo.svg"
                  aria-label="homepage"
                  width="101px"
                  height="64px"
                />
              </LogoContainer>
            </NavLink>
            <FooterContainer>
              <SocialLink
                href="https://github.com/Daily-Disciple"
                src="github.svg"
              />
              <SocialLink
                href="https://www.linkedin.com/company/daily-disciple/"
                src="linkedin.svg"
              />
            </FooterContainer>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
